import RFFDecimalField from './RFFDecimalField';

export default RFFDecimalField;



// WEBPACK FOOTER //
// ./src/components/form/RFFDecimalField/index.jsx